import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HotelReviewsResponse } from '../../../models/hotels/HotelReviewsResponse';

export interface DialogData<T> {
    title: string,
    rating: any,
    reviews: T;
}

@Component({
    selector: 'app-hotelreview',
    templateUrl: './hotelreview.component.html',
    styleUrls: ['./hotelreview.component.scss'],
    standalone: false
})
export class HotelreviewComponent implements OnInit {
    datas: any;
    title: string = '';
    food: number[] = [];
    overall: number[] = [];
    hotel: number[] = [];
    leisure: number[] = [];
    location: number[] = [];
    room: number[] = [];
    service: number[] = [];
    constructor(@Inject(MAT_DIALOG_DATA) protected data: DialogData<any>) { }

    ngOnInit(): void {
        this.title = this.data?.title;
        this.datas = this.data?.reviews;
        this.initData();
        this.initReviwlist();
    }

    async initReviwlist() {
        for (let i = 0; i < this.datas.hotelReviewList?.length; i++) {
            switch (this.datas.hotelReviewList[i].travelCompanion) {
                case 'single':
                    this.datas.hotelReviewList[i].travelCompaniontext = 'Single';
                    break;
                case 'couple':
                    this.datas.hotelReviewList[i].travelCompaniontext = 'Paar';
                    break;
                case 'family':
                    this.datas.hotelReviewList[i].travelCompaniontext = 'Familie';
                    break;
                case 'friends':
                    this.datas.hotelReviewList[i].travelCompaniontext = 'Freunde';
                    break;

                default:
                    break;
            }

            this.datas.hotelReviewList[i].food = [];
            this.datas.hotelReviewList[i].overall = [];
            this.datas.hotelReviewList[i].hotel = [];
            this.datas.hotelReviewList[i].leisure = [];
            this.datas.hotelReviewList[i].location = [];
            this.datas.hotelReviewList[i].room = [];
            this.datas.hotelReviewList[i].service = [];
            if (this.datas.hotelReviewList[i].rating?.food > 0) {
                const tmpfood = Math.floor(this.datas.hotelReviewList[i].rating?.food * 6 / 100);
                for (let j = 0; j < 6; j++) {
                    if (j < tmpfood) {
                        this.datas.hotelReviewList[i].food.push(1);
                    } else {
                        this.datas.hotelReviewList[i].food.push(0);
                    }
                }
            }
            if (this.datas.hotelReviewList[i].rating?.overall > 0) {
                const tmpoverall = Math.floor(this.datas.hotelReviewList[i].rating?.overall * 6 / 100);
                for (let j = 0; j < 6; j++) {
                    if (j < tmpoverall) {
                        this.datas.hotelReviewList[i].overall.push(1);
                    } else {
                        this.datas.hotelReviewList[i].overall.push(0);
                    }
                }
            }
            if (this.datas.hotelReviewList[i].rating?.hotel > 0) {
                const tmp = Math.floor(this.datas.hotelReviewList[i].rating?.hotel * 6 / 100);
                for (let j = 0; j < 6; j++) {
                    if (j < tmp) {
                        this.datas.hotelReviewList[i].hotel.push(1);
                    } else {
                        this.datas.hotelReviewList[i].hotel.push(0);
                    }
                }
            }
            if (this.datas.hotelReviewList[i].rating?.leisure > 0) {
                const tmp = Math.floor(this.datas.hotelReviewList[i].rating?.leisure * 6 / 100);
                for (let j = 0; j < 6; j++) {
                    if (j < tmp) {
                        this.datas.hotelReviewList[i].leisure.push(1);
                    } else {
                        this.datas.hotelReviewList[i].leisure.push(0);
                    }
                }
            }
            if (this.datas.hotelReviewList[i].rating?.location > 0) {
                const tmp = Math.floor(this.datas.hotelReviewList[i].rating?.location * 6 / 100);
                for (let j = 0; j < 6; j++) {
                    if (j < tmp) {
                        this.datas.hotelReviewList[i].location.push(1);
                    } else {
                        this.datas.hotelReviewList[i].location.push(0);
                    }
                }
            }
            if (this.datas.hotelReviewList[i].rating?.room > 0) {
                const tmp = Math.floor(this.datas.hotelReviewList[i].rating?.room * 6 / 100);
                for (let j = 0; j < 6; j++) {
                    if (j < tmp) {
                        this.datas.hotelReviewList[i].room.push(1);
                    } else {
                        this.datas.hotelReviewList[i].room.push(0);
                    }
                }
            }
            if (this.datas.hotelReviewList[i].rating?.service > 0) {
                const tmp = Math.floor(this.datas.hotelReviewList[i].rating?.service * 6 / 100);
                for (let j = 0; j < 6; j++) {
                    if (j < tmp) {
                        this.datas.hotelReviewList[i].service.push(1);
                    } else {
                        this.datas.hotelReviewList[i].service.push(0);
                    }
                }
            }
        }
    }

    async initData() {
        if (this.data.rating?.food > 0) {
            const tmpfood = Math.floor(this.data.rating?.food * 6 / 100);
            for (let i = 0; i < 6; i++) {
                if (i < tmpfood) {
                    this.food.push(1);
                } else {
                    this.food.push(0);
                }
            }
        }
        if (this.data.rating?.overall > 0) {
            const tmpoverall = Math.floor(this.data.rating?.overall * 6 / 100);
            for (let i = 0; i < 6; i++) {
                if (i < tmpoverall) {
                    this.overall.push(1);
                } else {
                    this.overall.push(0);
                }
            }
        }
        if (this.data.rating?.hotel > 0) {
            const tmp = Math.floor(this.data.rating?.hotel * 6 / 100);
            for (let i = 0; i < 6; i++) {
                if (i < tmp) {
                    this.hotel.push(1);
                } else {
                    this.hotel.push(0);
                }
            }
        }
        if (this.data.rating?.leisure > 0) {
            const tmp = Math.floor(this.data.rating?.leisure * 6 / 100);
            for (let i = 0; i < 6; i++) {
                if (i < tmp) {
                    this.leisure.push(1);
                } else {
                    this.leisure.push(0);
                }
            }
        }
        if (this.data.rating?.location > 0) {
            const tmp = Math.floor(this.data.rating?.location * 6 / 100);
            for (let i = 0; i < 6; i++) {
                if (i < tmp) {
                    this.location.push(1);
                } else {
                    this.location.push(0);
                }
            }
        }
        if (this.data.rating?.room > 0) {
            const tmp = Math.floor(this.data.rating?.room * 6 / 100);
            for (let i = 0; i < 6; i++) {
                if (i < tmp) {
                    this.room.push(1);
                } else {
                    this.room.push(0);
                }
            }
        }
        if (this.data.rating?.service > 0) {
            const tmp = Math.floor(this.data.rating?.service * 6 / 100);
            for (let i = 0; i < 6; i++) {
                if (i < tmp) {
                    this.service.push(1);
                } else {
                    this.service.push(0);
                }
            }
        }
    }
}
